<template>
  <div class="loans-pro-item">
    <p class="title">{{ safeItem.title }}</p>
    <p class="desc">{{ $t("loans.orderno") }} : {{ safeItem.order_num }}</p>
    <p class="desc">{{ $t("loans.Amount") }} : {{ safeItem.amount }}</p>
    <p class="desc">{{ $t("loans.AllInterest") }} : {{ safeItem.interest }}</p>
    <p class="desc">
      {{ $t("loans.RepaymentDate") }} :
      {{ safeItem.repayment_time ? safeItem.repayment_time : "--" }}
    </p>
    <p class="desc" style="font-weight: 600 !;">
      {{ $t("common.total") }} :
      <span :class="safeItem.is_repayment == 0 ? 'data-down' : 'data-up'" style="font-weight: 600;">
        {{ safeItem.total_amount }} (
        {{ safeItem.is_repayment_text }}
        )</span
      >
    </p>
    <div
      class="loans-application"
      :class="safeItem.status == 3 ? 'data-down' : 'data-up'"
    >
      <span>{{ safeItem.status_text }}</span>
      <span
        v-if="safeItem.status == 1"
        style="margin-left: 10px"
        class="link-btn"
        @click="CancelLoanApply(safeItem.id)"
        >{{ $t("common.cancel") }}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "LoanOrder",
  props: ["item"],
  computed: {
    safeItem() {
      return this.item || {};
    },
  },
  methods: {
    async CancelLoanApply(id) {
      await this.$http({
        method: "post",
        url: "cancelLoanApply",
        data: { id: id },
      }).then((res) => {
        this.$toast.success(res.msg);
        this.$emit("reset-data");
      });
    },
  },
};
</script>

<style>
</style>
